import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = '' }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-accent-400 transition-colors cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-900">
        <img
          src={movie.cover}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 诱人的女员工hd影视专区`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {movie.rating > 0 && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
            {movie.rating.toFixed(1)}
          </span>
        )}
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs">
          {movie.type === 'movie' ? '电影' : '剧集'}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-foreground-950 text-base truncate group-hover:text-accent-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-background-300">·</span>
          <span>{movie.region}</span>
          <span className="text-background-300">·</span>
          <span className="truncate">{movie.genres.join(' / ')}</span>
        </div>
        <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
          {movie.synopsis}
        </p>
      </div>
    </Link>
  );
}